import { render, staticRenderFns } from "./ProductTypesEntity.vue?vue&type=template&id=47cb5ed8&"
import script from "./ProductTypesEntity.vue?vue&type=script&lang=js&"
export * from "./ProductTypesEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports